import { axios } from '$app-web/api/axios';
import { RegisteringStudy } from '$app-web/types';
import { errorHandle } from '$app-web/utils';

import { Endpoints } from '../constant';

export async function fetchRegisteringStudyInfo(studyId: number | string) {
    try {
        const params = { study_id: studyId };
        const { data } = await axios.get<RegisteringStudy>(Endpoints.Study.Info, { params });

        return data;
    } catch (error) {
        errorHandle.anError(error as Error);
        throw error;
    }
}
